import type { ComponentProps } from 'react';

interface Props extends ComponentProps<'div'> {
  min: number;
  max: number;
  value: number[];
  thumbSize?: number;
}

export const SliderRuler = ({ min, max, value, thumbSize = 16 }: Props) => {
  const range = max - min;

  const getStepSize = () => {
    if (range <= 10) return 1;
    if (range <= 20) return 2;
    if (range <= 80) return 5;
    return 10;
  };

  const step = getStepSize();
  const ticks = Array.from({ length: Math.floor(range / step) + 1 }, (_, i) => min + i * step);

  // Convert value to a consistent array for uniform handling
  const [valStart, valEnd] = Array.isArray(value) ? value : [value, value];

  return (
    <div
      className="relative h-8 w-full"
      style={{
        padding: `0 ${thumbSize / 2}px`,
      }}
    >
      <div className="absolute inset-0 right-2 left-2">
        {ticks.map((tick) => {
          const percent = ((tick - min) / range) * 100;
          const isStart = tick === valStart;
          const isEnd = tick === valEnd;
          const isInRange = tick >= valStart && tick <= valEnd;

          return (
            <div key={tick} className="absolute flex flex-col" style={{ left: `calc(${percent}% - 0.5px)` }}>
              <div
                className={`w-px ${
                  isStart || isEnd ? 'h-2 bg-gray-900' : isInRange ? 'h-1 bg-gray-900' : 'h-1 bg-gray-400'
                }`}
              />
              <span
                className={`absolute left-[-3px] mt-2 text-xs ${
                  isStart || isEnd ? 'font-semibold text-gray-900' : isInRange ? 'text-gray-900' : 'text-gray-400'
                }`}
              >
                {tick}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
};
